import { render, staticRenderFns } from "./sub-icon-line-box.vue?vue&type=template&id=d23930cc&scoped=true&"
import script from "./sub-icon-line-box.vue?vue&type=script&lang=js&"
export * from "./sub-icon-line-box.vue?vue&type=script&lang=js&"
import style0 from "./sub-icon-line-box.vue?vue&type=style&index=0&id=d23930cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d23930cc",
  null
  
)

export default component.exports